/*
 * @format
 */

import * as actions_ from './actions/actions';
import * as controlsActions_ from './actions/controls-actions';
import * as settingsActions_ from './actions/settings-actions';
import * as resumeActions_ from './actions/resume-registration';
import * as scheduleActions_ from './actions/schedule-actions';
import * as partnerAccessRequestActions from './actions/partner-access-requests-actions';

import * as selectors_ from './selectors';
import * as controlsSelectors_ from './controls-selectors';
import * as scheduleSelectors_ from './selectors/schedule-selectors';
import * as desiredStateSelectors_ from './selectors/desired-state-selectors';
import * as reducer_ from './reducer';
import * as deviceReducers_ from './device-reducer';
import * as scheduleReducer_ from './reducers/schedule-reducer';
import * as draftScheduleReducer_ from './reducers/draft-schedule-reducer';
import * as messages_ from './web_socket_messages/messages';
import * as pendingReducers_ from './reducers/pending-reducer';
import * as pendingCustomReducer_ from './reducers/pending-custom-reducer';
import * as completedReducer from './reducers/completed-messages';
import * as siRegistrationReducer from './reducers/si-registration';
import * as resumeRegReducer from './reducers/resume-registration';
import settingsReducer from './reducers/settings-reducer';
import notificationsReducer from './reducers/notifications-reducer';
import modeChangeTracker from './reducers/mode-change-tracker';
import deviceService from './reducers/device-service-reducer';
import pendingDsrCommandsReducer from './reducers/pending-dsr-commands-reducer';
import dsr from './reducers/dsr-reducer';
import desiredState from './reducers/desired-state-reducer';
import ownDesiredRequests from './reducers/own-desired-requests-reducer';
import partnerAccessRequestsReducer from './reducers/partner-access-requests-reducer';
import haloNotificationMessagesReducer from './reducers/halo-notification-messages-reducer';

import saga_ from './sagas';

import help from './help/Help';

import jsonApiSetup_ from './api/jsonapi';
import * as deviceGeoStatus from './reducers/device-geo-reducer';
import * as awaitingZoneStatus from './reducers/awaiting-zone-reducer';

export const helpData = help;

export const actions = {
  ...actions_,
  ...controlsActions_,
  ...settingsActions_,
  ...resumeActions_,
  ...scheduleActions_,
  ...partnerAccessRequestActions,
};
export const selectors = {
  ...selectors_,
  ...controlsSelectors_,
  ...scheduleSelectors_,
  ...desiredStateSelectors_,
};
export const reducers = {
  ...reducer_,
  ...deviceReducers_,
  ...scheduleReducer_,
  ...draftScheduleReducer_,
  ...deviceGeoStatus,
  ...awaitingZoneStatus,
  ...pendingReducers_,
  ...pendingCustomReducer_,
  ...completedReducer,
  ...siRegistrationReducer,
  ...resumeRegReducer,
  settingsReducer,
  notificationsReducer,
  modeChangeTracker,
  deviceService,
  pendingDsrCommandsReducer,
  dsr,
  desiredState,
  ownDesiredRequests,
  partnerAccessRequestsReducer,
  haloNotificationMessagesReducer,
};

export const webSocketMessages = messages_;

export const jsonApiSetup = jsonApiSetup_;

export const rootSaga = saga_;
